import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { CvDto } from 'src/app/services/api-client/models';
import { CvRestControllerService } from 'src/app/services/api-client/services';
import { ParseCvService } from 'src/app/shared/services/parse-cv.service';

@Component({
  selector: 'app-cv-upload',
  templateUrl: './cv-upload.component.html',
  styleUrls: ['./cv-upload.component.scss']
})
export class CvUploadComponent implements OnInit {

  public parsing: boolean = false;
  @Output() public resultCv = new EventEmitter<CvDto>();

  constructor(
    private translate: TranslateService,
    private cvController: CvRestControllerService,
    private toastr: ToastrService,
    private bsModalRef: BsModalRef,
    private parseCvService: ParseCvService
  ) {}

  ngOnInit(): void {}

  file: File;

  onSelect(event) {
    this.file = event.addedFiles[0];
  }

  onRemove(event) {
    this.file = null;
  }

  parseFile() {
    if (this.file) {
      this.parsing = true;
      let params = {
        body: {
          file: this.file
        }
      }
      this.cvController.parseCv(params).subscribe((cvDto: CvDto) => {
        if(cvDto){
          this.parseCvService.emitUploadedCv(cvDto);
          this.parsing = false;
          this.parseCvService.closeUploadSideBar();
        }
        this.bsModalRef.hide();
      }, (error)=>{
        this.bsModalRef.hide();
        this.translate.get('error_cv_upload').subscribe((txt)=> this.toastr.error(txt));
        this.parseCvService.emitUploadedCv(null);
      });
    }
  }

  close() {
    this.parseCvService.closeUploadSideBar();
  }
}
